<div>
    <ssrs-reportviewer [reportserver]="reportServer" [reporturl]="reportUrl" [showparameters]="showParameters"
      [parameters]="parameters" [language]="language" [width]="width" [height]="height" [toolbar]="toolbar">
    </ssrs-reportviewer>
    ReportViewerModule
  </div>
